module.exports = __webpack_public_path__ + "img/navcourse.0238d270.jpg";